import { useContext } from 'react';

import { mdiTimerOutline } from '@mdi/js';
import { Paper } from '@mui/material';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import DashboardMetricPiece from './DashboardMetricPiece';
import { getTimeMetric } from './getTimeMetric';
import { useDashboardData } from './useDashboardData';
import { DashboardContext } from '../../context/DashboardContext';

const StudentTalkTimePaper = styled(Paper)`
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 17px 26px;
`;

const DashboardStudentTalkTimeMetric: React.FC = () => {
    const { metricTranslations } = useContext(DashboardContext);
    const { sessionSummary: summary, classAverages } = useDashboardData();
    const { t } = useTranslation('dashboard');
    return (
        <StudentTalkTimePaper>
            <DashboardMetricPiece
                id="dashboard-metric-average-students-talk-time"
                titleText={t('average-students-talk-time')}
                titleIcon={mdiTimerOutline}
                metricValue={getTimeMetric(summary.averageTalkTime.student, metricTranslations)}
                averageMetricValue={getTimeMetric(classAverages?.averageTalkTime.student, metricTranslations)}
                metricValueColor={'#BA36CE'}
            />
        </StudentTalkTimePaper>
    );
};

export default DashboardStudentTalkTimeMetric;
